import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";

import axios from "axios";
import { LoadingIcon } from '../Common/Loading_Icon';
import NavbarSelector from '../NavbarSelector.jsx';

import { setUserSession } from "../../Actions/userSessionActions";
import { Trans } from 'react-i18next';
class EULA extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading_page: true,
            eula_data: {}
        };

        this.showEula = this.showEula.bind(this);
        this.createEulaMarkup = this.createEulaMarkup.bind(this);
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        document.title = "EULA - FleetXPress"
        var self = this;
        let query = new URLSearchParams(this.props.location.search);
        var lang = (query.get('lang') ? ('/' + query.get('lang')) : '');

        axios.get('/ajax/terms' + lang)
        .then(function(response) {
            self.setState({
                loading_page: false,
                eula_data: response?.data
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    showEula(event) {
        if ($("#eula-container").hasClass("eula-hidden")) {
            $("#eula-container").removeClass("eula-hidden").addClass("eula-visible");
        } else {
            $("#eula-container").removeClass("eula-visible").addClass("eula-hidden");
        }
    }

    createEulaMarkup(html_text) {
        return {__html: html_text}
    }

    validate(event) {
        event.preventDefault();
        if($("#check_accepted_terms:checkbox:checked").length > 0)
        {
            var self = this;
            var userSessionObj = self.props.userSession;            

            axios({
                method: 'post',
                url: '/ajax/eula',
                data: {check_accepted_terms: 1},
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            })
            .then(function (response) {
                userSessionObj.user.eula_accepted = true;
                self.props.dispatch({type: "SET_SESSION_OEM", payload: userSessionObj.user});
                //self.props.history.push('/home');
                window.location.href = "/home";
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        }
        else
        {
            $("#error_terms").addClass("red-alert").removeClass("caption");
        }
    }

    render() {        
        if (!this.state.loading_page) {
            if(this.props.userSession.user.eula_accepted == false) {
                return (
                    <div className = "bkg-primary h-100">
                        <div id = "eula-container" className = "eula-hidden">
                            <div className = "eula-form">
                                <div className = "card">
                                    <div className = "card-divider">
                                        <div className = "heading"><Trans>Terms and Condition of Use</Trans></div>
                                    </div>
                                    <div className = "eula-text">
                                        <div className = "card-section">
                                            <div className = "body mt-12">                                        
                                                {
                                                    !this.state.loading_page ?
                                                        <p dangerouslySetInnerHTML={this.createEulaMarkup(this.state.eula_data.eula_text)}></p>
                                                    :
                                                    <p><Trans>Loading Eula ...</Trans> </p>
                                                }
                                            </div>
                                        </div>
                                    </div> 
                                    {/*End EULA Text*/}

                                    <div className = "card-section">
                                        <div className = "eula-check">
                                            <input type = "checkbox" name = "check_accepted_terms" id = "check_accepted_terms" value = '1' />
                                            <label for = "check_accepted_terms">
                                                <Trans>I have read and accept the</Trans> <a onClick = {(event) => { this.showEula(event)}}><Trans>Terms and Conditions</Trans></a> <Trans>of Use</Trans>
                                            </label>
                                        </div>

                                        <input type = "button" className = "button primary eula-button w-100 no-margin" value = "Continue" onClick = {(event) => { this.validate(event)}} />

                                        <div id = "error_terms" className = "caption no-margin mt-12 align-center">
                                            <Trans>Please accept the terms and conditions to continue</Trans>
                                        </div>
                                    </div>
                                    {/*End Card Section*/}
                                </div> 
                                {/*End Card*/}
                            </div> 
                            {/*End EULA Form*/}
                        </div> 
                        {/*End EULA Container*/}
                    </div>
                )
            } else {
                return (
                    <div className = "bkg-white-dark pt-24">
                        {
                            this.props.userSession.logged_in ?
                                <NavbarSelector history={this.props.history} match={this.props.match} location={this.props.location}/>
                            :
                                <span />
                        }
                        <div id='top-content-wrap' className="approved-eula-container bkg-white-dark">
                            <div id='top-content' className='site-boxed'>
                                <div className='privacy-container'>
                                    <div className='displaylarge'><Trans>Terms and Conditions of Use</Trans></div>
                                    <div className = 'card'>
                                        <div className = "card-section" style={{textAlign: 'justify'}}>
                                            {
                                                !this.state.loading_page ?
                                                    <p dangerouslySetInnerHTML={this.createEulaMarkup(this.state.eula_data.eula_text)}></p>
                                                :
                                                <LoadingIcon />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        } else {
            return (
                <LoadingIcon />
            )
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(EULA)